import { useState } from "react";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, getDocs } from "firebase/firestore";
import { app, db } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import { FaEnvelope, FaLock, FaSignInAlt, FaHome } from "react-icons/fa";
import logo from "../assets/TW logo img.jpeg";

function AdminLogin() {
  const auth = getAuth(app);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const loginAdmin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);

      const adminSnapshot = await getDocs(collection(db, "admins"));

      let isAdmin = false;

      adminSnapshot.forEach((doc) => {
        const data = doc.data();

        if (
          data.email &&
          data.email.toLowerCase() === email.toLowerCase() &&
          data.role === "admin"
        ) {
          isAdmin = true;
        }
      });

      if (isAdmin) {
        alert("Admin Login Successful");
        navigate("/admin-dashboard");
      } else {
        await signOut(auth);
        alert("Access Denied. You are not authorized as an administrator.");
      }
    } catch (error) {
      alert("Wrong Email or Password");
    }
  };

  return (
    <div
      className="container-fluid d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #eef4ff, #f8fbff)",
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          width: "430px",
          borderRadius: "22px",
          padding: "35px",
          border: "none",
        }}
      >
        <div className="text-center mb-4">

          <div
            style={{
              width: "95px",
              height: "95px",
              borderRadius: "50%",
              overflow: "hidden",
              margin: "0 auto 18px",
              border: "3px solid #198754",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
            }}
          >
            <img
              src={logo}
              alt="Trading Wealth"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
            />
          </div>

          <h2 className="fw-bold">Admin Login</h2>

          <p className="text-muted">
            Welcome back! Please login to continue.
          </p>

        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">
            <FaEnvelope className="me-2" />
            Email Address
          </label>

          <input
            type="email"
            className="form-control"
            placeholder="Enter Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">
            <FaLock className="me-2" />
            Password
          </label>

          <input
            type="password"
            className="form-control"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          className="btn btn-success w-100"
          style={{
            height: "48px",
            fontWeight: "600",
            borderRadius: "10px",
          }}
          onClick={loginAdmin}
        >
          <FaSignInAlt className="me-2" />
          Login
        </button>

        <Link
          to="/"
          className="btn btn-outline-secondary w-100 mt-3"
          style={{
            height: "48px",
            lineHeight: "32px",
            borderRadius: "10px",
          }}
        >
          <FaHome className="me-2" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}

export default AdminLogin;